import initAtcPopup from '../../components/atc-popup';

// Swym's collection wishlist script watches for new cards, but only finds them
// *inside* each added node - and load more appends the card roots themselves
// as direct grid children, so its observer never matches them. Its public
// reinitialize() (attached to Swym's SDK object once loaded) adds buttons to
// any card still missing one. The older SmartWishlist reload is kept for
// stores still running that app.
const reloadWishlistButtons = () => {
  window._swat?.advancedCollectionsApi?.reinitialize?.();
  if (typeof window.ReloadSmartWishlist === 'function') {
    window.ReloadSmartWishlist();
  }
};

const initLoadMorePagination = () => {
  const productGridEl = document.querySelector('[data-product-grid]');
  const paginationEl = document.querySelector('[data-pagination]');
  if (!productGridEl || !paginationEl) return;

  const fetchResults = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    } catch (err) {
      console.error('Error fetching next page of products:', err);
    }
  };

  const appendNewProducts = (resultsDoc) => {
    // Child combinators only: a descendant `.grid` selector also matched the
    // promo card's own `ul.grid` of CTA buttons, so its <li>s were appended to
    // the product grid as stray items whenever the next page contained the card.
    const newGridItems = resultsDoc.querySelectorAll('[data-product-grid] > .grid > *:not([data-promo-card])');
    const currentGridEl = productGridEl.querySelector(':scope > .grid');
    if (!newGridItems.length || !currentGridEl) return;

    currentGridEl.append(...newGridItems);
  };

  const updatePagination = (resultsDoc) => {
    const newPaginationEl = resultsDoc.querySelector('[data-pagination]');
    if (!newPaginationEl) return;

    // Replacing innerHTML removes the currently focused load-more button from
    // the DOM. The browser then moves focus to <body>, which in Chrome jumps
    // the scroll position to the top of the page - preventScroll on the new
    // focus target below doesn't stop this, since the jump already happened
    // as a side effect of the old button being removed. Capturing and
    // restoring the scroll position guarantees it, regardless of what the
    // browser did internally.
    const { scrollX, scrollY } = window;
    paginationEl.innerHTML = newPaginationEl.innerHTML;
    const newButton = paginationEl.querySelector('[data-load-more-button]');
    if (newButton) newButton.focus({ preventScroll: true });
    window.scrollTo(scrollX, scrollY);
  };

  const handleLoadMoreClick = async (e) => {
    const button = e.target.closest('[data-load-more-button]');
    if (!button) return;
    e.preventDefault();

    // disabled has no effect on <a> elements, so this guard - not the
    // attribute below - is what actually stops a second in-flight fetch
    if (button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    button.setAttribute('disabled', '');
    const resultsDoc = await fetchResults(button.href);
    button.removeAttribute('aria-busy');
    button.removeAttribute('disabled');
    if (!resultsDoc) return;

    appendNewProducts(resultsDoc);
    updatePagination(resultsDoc);
    initAtcPopup();
    reloadWishlistButtons();

    window.history.pushState({}, '', button.href);
  };

  paginationEl.addEventListener('click', handleLoadMoreClick);
};

export default initLoadMorePagination;
